/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_C1Inputs */

const en_guide_what_is_json_c1 = /** @type {(inputs: Guide_What_Is_Json_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objects, arrays, and the six value types`)
};

const ko_guide_what_is_json_c1 = /** @type {(inputs: Guide_What_Is_Json_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`객체와 배열, 그리고 여섯 가지 값 타입`)
};

const ja_guide_what_is_json_c1 = /** @type {(inputs: Guide_What_Is_Json_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オブジェクトと配列、6つの値の型`)
};

/**
* | output |
* | --- |
* | "Objects, arrays, and the six value types" |
*
* @param {Guide_What_Is_Json_C1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_c1 = /** @type {((inputs?: Guide_What_Is_Json_C1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_C1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_c1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_c1(inputs)
	return ja_guide_what_is_json_c1(inputs)
});